import {
  CITY_LIST,
  DISTRICT_LIST,
  PINCODE_AUTO_LIST,
  STATE_LIST,
} from "./types";

export const fetchStateList = (onSuccess, onError) => {
  return {
    type: STATE_LIST,
    onSuccess,
    onError,
  };
};

export const fetchDistrictList = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fetchCityList = (data, onSuccess, onError) => {
  return {
    type: CITY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fetchPincodeAutoList = (data, onSuccess, onError) => {
  return {
    type: PINCODE_AUTO_LIST,
    data,
    onSuccess,
    onError,
  };
};
